import * as angular from 'angular';
import * as DesktopNavigationComponent from './desktop';
import * as MobileNavigationComponent from './mobile';

const module = angular.module('navigation-component', [
    DesktopNavigationComponent.module.name,
    MobileNavigationComponent.module.name
]);

export { module };
